export const dataInterestSelector = state => {
    return state.ui.dataInterest;
};
